// components/ActivityInsights/TopOffenders.js

import { useMemo, useState } from "react";
import { generateDummyEvents } from "./DummyData";

function getTopOffenders(events, groupBy) {
  const map = {};
 
  
  

 
	 events.forEach(e => {
    const key = e[groupBy] || "Unknown";

    if (!map[key]) {
      map[key] = { bookings: 0, utilised: 0 };
    }

    map[key].bookings += 1;
    if (e.checkedIn) map[key].utilised += 1;
  });

  return Object.entries(map)
    .map(([name, data]) => {
      const rate = data.bookings
        ? data.utilised / data.bookings
        : 0;

      return {
        name,
        bookings: data.bookings,
        utilisationRate: rate
      };
    })
    .filter(d => d.bookings >= 5) // avoid noise
    .sort((a, b) => a.utilisationRate - b.utilisationRate)
    .slice(0, 10);
}

export default function TopOffenders() {
	const events = useMemo(() => generateDummyEvents(), []);
  const [groupBy, setGroupBy] = useState("workspaceId");
  
  const thisContainer = {
      marginTop: "16px",
      padding: "12px",
      borderRadius: "10px",
      background: "rgba(255,255,255,0.02)",
      border: "1px solid rgba(255,255,255,0.05)",
  	flexDirection:'column',
  	width:'230px',
	marginLeft:'10px'
    };

  const offenders = useMemo(() => {
    return getTopOffenders(events, groupBy);
  }, [events, groupBy]);

  const getColor = (rate) => {
    if (rate < 0.4) return "#dc2626";   // red
    if (rate < 0.7) return "#f59e0b";   // amber
    return "#16a34a";                   // green
  };

  if (!events.length) return <div>Loading...</div>;

  return (
     <div style={thisContainer}>
      
      <div style={{fontSize:'12px', color:'#aaa', paddingBottom:'10px'}}>Opportunity Areas</div>

      {/* 🔘 Toggle */}
      <div style={{ marginBottom: "10px" }}>
	  <div style={{
	    display: "flex",
	    gap: "6px",
	    marginBottom: "10px"
	  }}>
	    {[
	      { label: "Rooms", value: "workspaceId" },
	      { label: "Teams", value: "team" },
	      { label: "Departments", value: "department" }
	    ].map(btn => (
	      <button
	        key={btn.value}
	        onClick={() => setGroupBy(btn.value)}
	        style={{
	          padding: "4px 10px",
	          fontSize: "12px",
	          borderRadius: "6px",
	          border: "1px solid rgba(255,255,255,0.1)",
	          background:
	            groupBy === btn.value
	              ? "rgba(255,255,255,0.15)"
	              : "transparent",
	          color: "#fff",
	          cursor: "pointer",
	          transition: "all 0.2s ease"
	        }}
	      >
	        {btn.label}
	      </button>
	    ))}
	  </div>
      </div>

      {/* 📋 List */}
      <div>
        {offenders.map((o, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              justifyContent: "space-between",
			  alignItems:'center',
              height:"30px",
              borderBottom: "1px solid rgba(255,255,255, 0.1)"
            }}
          >
            <span style={{fontSize:'12px', color:'#aaa', }}>{i + 1}. {o.name}</span>

            <span style={{ color: getColor(o.utilisationRate), fontSize: "12px" }}>
              {(o.utilisationRate * 100).toFixed(0)}%
            </span>
          </div>
        ))}
      </div>

    </div>
  );
}